var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-list-column',{staticClass:"column",attrs:{"format":_vm.format,"type":"stat"}},[_c('i',{staticClass:"fa fa-weight-hanging"})])
}
var staticRenderFns = []

export { render, staticRenderFns }